export enum LogLevel {
  ERROR = 'error',
  WARN = 'warn', 
  INFO = 'info',
  DEBUG = 'debug'
}

export function getLogLevel(): LogLevel {
  const envLogLevel = process.env.LOG_LEVEL?.toLowerCase();
  if (envLogLevel && Object.values(LogLevel).includes(envLogLevel as LogLevel)) {
    return envLogLevel as LogLevel;
  }

  // Environment-based defaults
  switch (process.env.NODE_ENV) {
    case 'development':
      return LogLevel.ERROR;
    case 'test':
      return LogLevel.WARN;
    case 'production':
      return LogLevel.INFO;
    default:
      return LogLevel.INFO;
  }
}

export function shouldLog(level: LogLevel): boolean {
  const currentLevel = getLogLevel();
  const levels: Record<LogLevel, number> = {
    [LogLevel.ERROR]: 0,
    [LogLevel.WARN]: 1,
    [LogLevel.INFO]: 2,
    [LogLevel.DEBUG]: 3,
  };
  
  return levels[level] <= levels[currentLevel];
}
